import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private http = inject(HttpClient);
  private readonly endPoint = environment.API_ENDPOINT + `files/`;
  private readonly endPoint_V2 = environment.API_ENDPOINT + `files/`;
  progress: number = 0;
  upload(files: File | File[], organizationId: string): Observable<any> {
    const formData = new FormData();
    if (Array.isArray(files)) {
      for (const file of files) {
        formData.append('file', file);
      }
    } else {
      formData.append('file', files);
    }
    // Append the organizationId property to the FormData
    formData.append('organizationId', organizationId);
    return this.http.post(this.endPoint + 'file', formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
  uploadAsPromise(files: File | File[], organizationId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.upload(files, organizationId).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round((event.loaded / event.total) * 100);
          }
          if (event.type === HttpEventType.Response) {
            this.progress = 0;
            resolve(event.body);
          }
        },
        err => {
          this.progress = 0;
          reject(err);
        }
      );
    });
  }
  viewAbleUrl(link?: string): Observable<any> {
    return this.http.get(this.endPoint_V2 + 'viewable-url?link=' + link);
  }
  tutorialUrl(type: string): Observable<any> {
    return this.http.get(this.endPoint + `tutorial-url?type=${type}`);
  }
  //==============JUST ONE METHOD-SERVICE FOR ADMIN SIDE FILE UPLOAD======================
  uploadFiles(files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('file', file);
    });
    return this.http.post(this.endPoint, formData);
  }
}
